<template>
    <div>
        <div class="normalheader ">
            <div class="hpanel">
                <div class="panel-body">
                    <div id="hbreadcrumb" class="pull-right m-t-lg">
                        <ol class="hbreadcrumb breadcrumb">
                            <li>
                                <router-link tag="a" :to="{name:'dashboard'}">Portada</router-link>
                            </li>
                            <li>
                                <span>Huéspedes</span>
                            </li>
                            <li class="active">
                                <span>{{ guestId ? 'Editar': 'Crear'}} huésped</span>
                            </li>
                        </ol>
                    </div>
                    <h2 class="font-light m-b-xs">
                        {{ guestId ? 'Editar': 'Crear'}} huésped
                    </h2>
                    <small>{{ guestId ? 'Editar': 'Crear'}} huésped</small>
                </div>
            </div>

        </div>
        <div class="content">
            <div class="hpanel hviolet">
                <div class="panel-heading hbuilt">
                    Huésped
                </div>
                <div class="panel-body">
                    <div class="row">
                        <div class="col-lg-3 text-center">
                            <i class="pe-7s-global fa-5x text-muted"></i>
                            <p class="m-t-md">
                                <strong>Huésped</strong> puede solicitar viajes, al ser creado se generará un código
                                único que le servirá para identificarse en el Portal Web.<br><br>
                                <strong>Importante:</strong> Verifica que el nombre y apellido ingresado es el correcto,
                                el código autogenerado por huésped no podrá ser modificado después de haber sido creado.
                            </p>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-md-4 form-group" v-if="!isHotel && !guestId">
                                    <label>Hotel *</label>
                                    <custom-input tipo="select" :field="$v.form.hotelId" :items="hotels"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Correo electrónico</label>
                                    <custom-input tipo="text" :field="$v.form.email"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Celular</label>
                                    <custom-input tipo="phone" :field="$v.form.phone" :defaultCountry="defaultCountry"
                                                  :country-changed="countryChanged"/>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Nombre *</label>
                                    <custom-input tipo="text" :field="$v.form.firstName"/>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label>Apellido *</label>
                                    <custom-input tipo="text" :field="$v.form.lastName"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>ID</label>
                                    <custom-input tipo="text" :field="$v.form.identity"/>
                                </div>

                                <div class="col-md-4 form-group">
                                    <label>Check-in *</label>
                                    <custom-input tipo="date" :field="$v.form.arrivalAt" future :init="false"/>
                                </div>
                                <div class="col-md-4 form-group">
                                    <label>Check-out *</label>
                                    <custom-input tipo="date" :field="$v.form.departureAt" future :init="false"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="text-right">
                        <a class="btn btn-primary" @click="save">Guardar</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {DASHBOARD, GUEST_EDIT, GUEST_LIST, GUEST_NEW} from "../../router/routes";
    import CustomInput from '../common/CustomInput.vue'
    import {email, maxLength, required, requiredIf} from 'vuelidate/lib/validators'
    import HotelService from '../../services/HotelService';
    import GuestService from '../../services/GuestService';
    import Util from '../../util/util';
    import Alert from "../../util/alert";
    import {mapGetters} from 'vuex'
    import * as moment from 'moment';
    import {dateGreaterThan} from "../../directives/customValidations";

    export default {
        name: GUEST_EDIT.name,
        props: ['guestId'],
        components: {CustomInput},
        data: () => ({
            dashboardRoute: DASHBOARD.route,
            hotels: [],
            defaultCountry: null,
            form: {
                hotelId: null,
                email: null,
                phone: null,
                dialCode: null,
                country: null,
                firstName: null,
                lastName: null,
                identity: null,
                arrivalAt: null,
                departureAt: null,
                isHotel: false,
                currentDate: moment().startOf('day')
            },
        }),
        watch: {
            guestId: function () {
                if (this.guestId) {
                    this.clear();
                    this.init(this.guestId);
                } else
                    this.clear();
            },
            isHotel: function(){
                this.form.isHotel = this.isHotel;
            }
        },
        computed: {
            ...mapGetters([
                'isHotel',
            ]),
        },
        validations: {
            form: {
                hotelId: {required: requiredIf((model) => {
                        return !model.isHotel;
                    })},
                email: {email, maxLength: maxLength(45)},
                phone: {maxLength: maxLength(50)},
                country: {},
                dialCode: {},
                firstName: {required, maxLength: maxLength(100)},
                lastName: {required, maxLength: maxLength(100)},
                identity: {maxLength: maxLength(20)},
                departureAt: { required, checkoutDateGreaterThan: dateGreaterThan('arrivalAt') },
                arrivalAt:  {required},
            }
        },
        methods: {
            async init(guestId) {
                const self = this;
                try {
                    if (!self.isHotel) {
                        const hotelsData = (await HotelService.listActiveHotels()).data.payload;
                        hotelsData.forEach(it => {
                            self.hotels.push({key: it.id, value: it.name})
                        });
                    }
                    if (guestId) {
                        const guest = (await GuestService.getGuest(guestId)).data.payload;
                        self.load(guest);
                    } else {
                        self.defaultCountry = 'PE';
                    }
                } catch (err) {
                    Alert.mensajeError(err.message);
                    self.$router.push({path: GUEST_NEW.route});
                }
            },
            load(guest) {
                const self = this;
                self.form.hotelId = Util.getOptionByKey(self.hotels, guest.hotelId);
                self.form.email = guest.email;
                self.form.address = guest.address;
                self.form.phone = guest.phone;
                self.form.firstName = guest.firstName;
                self.form.lastName = guest.lastName;
                self.form.identity = guest.identity;
                self.form.arrivalAt = guest.arrivalAt ? moment(guest.arrivalAt, 'YYYY-MM-DD').format('DD/MM/YYYY') : null;
                self.form.departureAt = guest.departureAt ? moment(guest.departureAt, 'YYYY-MM-DD').format('DD/MM/YYYY'): null;
                self.defaultCountry = guest.country ? guest.country : 'PE';

            },
            async save() {
                this.$v.$touch();
                if (this.$v.$error) return;


                const self = this;
                const data = {
                    ...self.form, ...{
                        hotelId: self.form.hotelId ? self.form.hotelId.key : null,
                        departureAt: self.form.departureAt ? moment(self.form.departureAt, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                        arrivalAt: self.form.arrivalAt ? moment(self.form.arrivalAt, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                    }
                };
                try {
                    if (self.guestId) {
                        const guestUpdated = (await GuestService.updateGuest(self.guestId, data)).data.payload;
                        self.load(guestUpdated);
                        Alert.mensajeExito("Huésped actualizado.");
                        self.$router.push(GUEST_LIST.route);
                    } else {
                        Alert.confirmacion("Una vez que el huésped ha sido registrado el código autogenerado no podrá ser modificado. ¿Deseas continuar?",
                            null,
                            async function () {
                                try {
                                    await GuestService.addGuest(data);
                                    self.clear();
                                    Alert.mensajeExito("Huésped creado.");
                                    self.$router.push(GUEST_LIST.route);
                                } catch (err) {
                                    Alert.mensajeError(err.message);
                                }
                            });
                    }
                    self.$v.$reset();
                } catch (err) {
                    Alert.mensajeError(err.message);
                }
            },
            countryChanged(e) {
                const self = this;
                self.form.dialCode = `+${e.dialCode}`;
                self.form.country = e.iso2;
            },
            clear() {
                const self = this;
                self.form.hotelId = self.form.email = self.form.firstName =
                    self.form.lastName = self.form.identity = self.form.arrivalAt = self.form.departureAt = self.form.country = null;
                self.form.phone = '';
            }
        },
        mounted() {
            const self = this;
            this.init(self.guestId);
            this.form.isHotel = this.isHotel;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/guest/GuestEditor.vue